export const version = 'v2.0.0-beta.0627'
export const photoAssetUrlPrefix = 'http://apps.lasermusicsg.com/phone/photo/'
export const videoAssetUrlPrefix = 'http://apps.lasermusicsg.com/phone/video/'

export const langKeyMap = [
  'zh_CN',
  // 'zh_TW',
  'en_US',
  'ms_MY',
  'id_ID',
]

export const colors = [
  '#79216a',
  '#af3055',
  '#c2374e',
  '#d9463d',
  '#e65a2d',
  '#ce5c27',
  '#cd7b14',
  '#b69a26',
  '#80963d',
  '#449471',
]
